import React, { useEffect, useState } from 'react';
import { FiCheckCircle, FiAlertCircle, FiX } from 'react-icons/fi';

interface ToastItem { id: number; kind: 'success' | 'error'; message: string }

// module-level store so any v2 component can call toast.success/error without props or Redux
let items: ToastItem[] = [];
let listeners: ((items: ToastItem[]) => void)[] = [];
let nextId = 1;

const emit = () => listeners.forEach(l => l(items));

const dismiss = (id: number) => {
    items = items.filter(x => x.id !== id);
    emit();
};

const push = (kind: ToastItem['kind'], message: string) => {
    const id = nextId++;
    items = [...items, { id, kind, message }];
    emit();
    // errors stay longer so there is time to read them
    setTimeout(() => dismiss(id), kind === 'error' ? 6000 : 3500);
};

export const toast = {
    success: (message: string) => push('success', message),
    error: (message: string) => push('error', message),
};

// mounted once in AppRouter for v2 users; stacks top right under the header
const Toaster: React.FC = () => {
    const [list, setList] = useState<ToastItem[]>(items);

    useEffect(() => {
        listeners.push(setList);
        return () => { listeners = listeners.filter(l => l !== setList); };
    }, []);

    return <div className="v2-toasts" aria-live="polite">
        {list.map(x => <div key={x.id} className={`v2-toast ${x.kind}`} role={x.kind === 'error' ? 'alert' : 'status'}>
            {x.kind === 'success' ? <FiCheckCircle className="icon" /> : <FiAlertCircle className="icon" />}
            <span className="message">{x.message}</span>
            <button type="button" className="close" aria-label="Dismiss" onClick={() => dismiss(x.id)}><FiX /></button>
        </div>)}
    </div>;
};

export default Toaster;
